import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const ColumnSampleValue_ = z.object({
  value: z.string().describe("A sample value from the column"),
  frequency: z.number().describe("How many times this value appears"),
});
export interface ColumnSampleValue extends z.infer<typeof ColumnSampleValue_> {}
export const ColumnSampleValue: z.ZodType<ColumnSampleValue> =
  ColumnSampleValue_;

const ColumnInfo_ = z.object({
  name: z.string().describe("The column header name from the file"),
  sampleValues: z
    .array(ColumnSampleValue)
    .describe("Sample values from the column with their frequencies"),
});
export interface ColumnInfo extends z.infer<typeof ColumnInfo_> {}
export const ColumnInfo: z.ZodType<ColumnInfo> = ColumnInfo_;

export const supplierAttributeValues = [
  "name",
  "street1",
  "street2",
  "city",
  "state",
  "postalCode",
  "country",
  "fullAddress",
  "phoneNumber",
  "website",
  "currency",
  "leadTimeDays",
  "contact1Name",
  "contact1Email",
  "contact1Phone",
  "contact2Name",
  "contact2Email",
  "contact2Phone",
  "contact3Name",
  "contact3Email",
  "contact3Phone",
  "None",
] as const;

export type SupplierAttribute = (typeof supplierAttributeValues)[number];

export const mapSupplierColumns = {
  name: "mapSupplierColumns" as const,
  input: z.object({
    columns: z
      .array(ColumnInfo)
      .describe(
        "Array of columns with their names and sample values for AI mapping",
      ),
  }),
  output: z.object({
    mappings: z
      .record(z.string(), createEnum(supplierAttributeValues))
      .describe(
        "Record mapping column names to supplier attributes (or None for unmapped)",
      ),
  }),
};
